"use strict";
/* eslint-disable react/prop-types */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var actions = __importStar(require("./actions"));
var Button_1 = __importDefault(require("../../components/Button/Button"));
var Icon_1 = __importDefault(require("../../components/Icon/Icon"));
/**
 * A Button which toggles the explorer.
 */
var ExplorerToggle = function (_a) {
    var children = _a.children, onToggle = _a.onToggle;
    return (react_1["default"].createElement(Button_1["default"], { dialogTrigger: true, onClick: onToggle },
        react_1["default"].createElement(Icon_1["default"], { name: "folder-open-inverse", className: "icon--menuitem" }),
        children,
        react_1["default"].createElement(Icon_1["default"], { name: "arrow-right", className: "icon--submenu-trigger" })));
};
var mapStateToProps = function () { return ({}); };
var mapDispatchToProps = function (dispatch) { return ({
    onToggle: function (page) { return dispatch(actions.toggleExplorer(page)); },
}); };
var mergeProps = function (_stateProps, dispatchProps, ownProps) { return ({
    children: ownProps.children,
    onToggle: dispatchProps.onToggle.bind(null, ownProps.startPage),
}); };
exports["default"] = react_redux_1.connect(mapStateToProps, mapDispatchToProps, mergeProps)(ExplorerToggle);
